{
  "title": "Monitoring",
  "intro": "Every server of the project as Autopilot sees it, the ones that need a look first. The numbers come from the agent's latest report and refresh every minute. Open a server to see its Autopilot tab.",
  "actions": {
    "alerts": "Project alerts",
    "enable": "Turn on",
    "enableFor": "Turn on Autopilot for {{name}}"
  },
  "tiles": {
    "label": "Project summary",
    "watched": "With Autopilot, of {{total}}",
    "critical": "Need attention",
    "problems": "With problems",
    "alerts": "Firing alerts",
    "securityUpdates": "Security updates",
    "off": "Without Autopilot"
  },
  "filter": {
    "label": "Find a server",
    "placeholder": "Name or IP address",
    "state": "State",
    "options": {
      "all": "All servers",
      "problems": "With problems",
      "critical": "Need attention",
      "notReporting": "Not reporting",
      "off": "Without Autopilot",
      "updates": "Updates available"
    },
    "noMatch": "No such servers."
  },
  "empty": {
    "title": "No servers in this project yet",
    "text": "Create a server with Autopilot: its load, services, containers and warnings will show up here."
  },
  "columns": {
    "server": "Server",
    "state": "State",
    "alerts": "Alerts",
    "cpu": "CPU",
    "memory": "Memory",
    "disk": "Disk",
    "load": "Load",
    "services": "Services",
    "containers": "Containers",
    "updates": "Updates",
    "certificates": "Certificates",
    "agent": "Agent"
  },
  "cells": {
    "off": "Autopilot is off",
    "alertsOf": "Alerts: {{count}} — open the alerts of {{name}}",
    "loadPerCore": "{{load}} per core",
    "servicesFailed": "failed: {{count}}",
    "servicesOk": "all running ({{total}})",
    "containersOff": "not watched",
    "containers": "{{running}} of {{total}} running",
    "containerProblems": "with problems: {{count}}",
    "updatesNone": "none",
    "updatesSecurity": "security: {{count}}",
    "updatesTotal": "total: {{count}}",
    "certificatesNotCollected": "not collected yet",
    "certificatesExpired": "expired: {{count}}",
    "certificatesExpiring": "expiring soon: {{count}}",
    "certificatesNext": "next on {{date}}"
  },
  "update": {
    "badge": "New version",
    "action": "Update",
    "actionFor": "Update the agent on {{name}}",
    "summary": "A new agent version is available for servers: {{count}}. The agent does not update itself: press «Update» and run the install command again; the metrics history stays.",
    "notice": "A new agent version is available: {{version}}. The agent does not update itself: get the install command and run it again; the metrics history stays.",
    "noticeAction": "Get the command"
  }
}
